import i18n from '../../../Utils/i18n';
import { RecordingSource } from '../../../Utils/Constants';

export function getRecordingSource(recordingSource = RecordingSource.G2W) {
  switch (recordingSource) {
    case RecordingSource.G2W:
      return i18n.t('recordings.source.standalone');
    case RecordingSource.G2S:
      return i18n.t('recordings.source.goToStage');
    case RecordingSource.G2S_EMBEDDED:
      return i18n.t('recordings.source.goToStageEmbedded');
    default:
      console.warn('invalid recording source');
  }
}



// WEBPACK FOOTER //
// ./src/GoToWebinar/Recordings/Utils/RecordingsContainerUtils.js